const DepartmentsPage = () => <div>Departments</div>;
export default DepartmentsPage;
